import { from } from 'rxjs';

// export * from './lib/epgu-chat.service';
// export * from './lib/epgu-chat.component';
// export * from './lib/epgu-chat.module';

export * from './lib/list.service';
export * from './lib/border/border.module';
export * from './lib/border/border.directive';
export * from './lib/list/list.module';
export * from './lib/list/list/list.component';

export * from './lib/chats-page/chats-page.module' // delete  // Ð­ÑÐ¾ Ð½Ð¾Ð²Ð¸Ð½ÐºÐ°
export * from './lib/chats-page/chats-page.component' //delete // Ð­ÑÐ¾ Ð½Ð¾Ð²Ð¸Ð½ÐºÐ°